import React from "react";
import { ProjectsCardsSc } from "./index.sc";
function Index(props: any) {
  return (
    <>
      <ProjectsCardsSc>
        <div>{props?.ProjectName}</div>
        <div>{props?.description}</div>
      </ProjectsCardsSc>
    </>
  );
}

export default Index;
